// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Jotai from "jotai";
import * as React from "react";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as Core__Option from "@rescript/core/src/Core__Option.bs.js";
import * as ReactFinalForm from "react-final-form";
import * as JotaiAtoms$OrcaPaymentPage from "../../Utilities/JotaiAtoms.bs.js";
import * as PaymentInputField$OrcaPaymentPage from "../PaymentInputField.bs.js";
import * as DynamicFieldsUtils$OrcaPaymentPage from "../../Utilities/DynamicFieldsUtils.bs.js";

function PhoneField(props) {
  var __isLabelHidden = props.isLabelHidden;
  var fieldConfig = props.fieldConfig;
  var isLabelHidden = __isLabelHidden !== undefined ? __isLabelHidden : false;
  var fieldRef = React.useRef(null);
  var path = fieldConfig.confirmRequestWritePath;
  var match = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.configAtom);
  var localeString = match.localeString;
  var match$1 = DynamicFieldsUtils$OrcaPaymentPage.resolveFieldTexts(fieldConfig, localeString);
  var maxLength = fieldConfig.maxInputLength;
  var autocomplete = Core__Option.getOr(fieldConfig.htmlAutocompleteAttribute, "tel-national");
  var validate = DynamicFieldsUtils$OrcaPaymentPage.resolveValidator(fieldConfig, localeString);
  var field = ReactFinalForm.useField(path, {
        validate: validate
      });
  var value = Core__Option.getOr(field.input.value, "");
  var invalid = field.meta.invalid;
  var showError = field.meta.touched && !field.meta.active;
  var isValid = showError ? !invalid : undefined;
  var errorString = showError && invalid ? Core__Option.getOr(field.meta.error, "") : "";
  return React.createElement(PaymentInputField$OrcaPaymentPage.make, {
              isValid: Caml_option.some(isValid),
              value: value,
              onChange: (function (ev) {
                  var val = ev.target.value.replace(/\D|\s/g, "");
                  field.input.onChange(val);
                }),
              onBlur: (function (_ev) {
                  field.input.onBlur();
                }),
              errorString: errorString,
              onFocus: (function (_ev) {
                  field.input.onFocus();
                }),
              fieldName: match$1.label,
              isLabelHidden: isLabelHidden,
              maxLength: maxLength,
              placeholder: match$1.placeholder,
              inputRef: fieldRef,
              autocomplete: autocomplete
            });
}

var make = PhoneField;

export {
  make ,
}
/* jotai Not a pure module */
